import { render, staticRenderFns } from "./MatchingTour.vue?vue&type=template&id=d0ea177a&scoped=true&"
import script from "./MatchingTour.vue?vue&type=script&lang=js&"
export * from "./MatchingTour.vue?vue&type=script&lang=js&"
import style0 from "./MatchingTour.vue?vue&type=style&index=0&id=d0ea177a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ea177a",
  null
  
)

export default component.exports